import { Container } from '@chakra-ui/react'
import { PageErrorCentered } from 'commons/components/layout/PageErrorCentered'
import PageLayout from 'commons/components/layout/PageLayout'
import { PageLoaderCentered } from 'commons/components/layout/PageLoaderCentered'
import { Spacing } from 'commons/design-system/tokens'
import useSuccessCollectInfo from 'commons/hooks/services/useSuccessCollectInfo'
import SuccessPageContent from 'features/success-page/components/SuccessPageContent'
import { SuccessPageFooter } from 'features/success-page/components/SuccessPageFooter'
import SuccessIcon from 'features/success-page/components/icons/SuccessIcon'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const MoneyPotSuccessPage = () => {
	const { t } = useTranslation()

	const transactionIdentifier = useMemo(() => {
		const urlParams = new URLSearchParams(window.location.search)
		return urlParams.get('transaction') || ''
	}, [])
	const collectSlug = useMemo(() => {
		const urlParams = new URLSearchParams(window.location.search)
		return urlParams.get('id') || ''
	}, [])
	const { data, isLoading, isError } = useSuccessCollectInfo({ transactionIdentifier, collectSlug })

	if (isLoading) {
		return <PageLoaderCentered />
	}

	if (isError) {
		return <PageErrorCentered message={t('success.error_fetching_data')} />
	}

	return (
		<PageLayout
			withConfetti
			alignItems='center'
			justifyContent='center'
			footer={<SuccessPageFooter />}
		>
			<Container
				maxW={'600px'}
				centerContent
				textAlign={'center'}
				px={Spacing.SM}
				mt={{ base: 10, md: 0 }}
			>
				<SuccessIcon />
				<SuccessPageContent data={data} isMoneyPot={true} />
			</Container>
		</PageLayout>
	)
}

export default MoneyPotSuccessPage
